/* TND Event Actions — shared, idempotent, delegated handler.
   Builds a timezone-correct .ics (UTC) and handles native share.
   Loaded once per section; the window guard makes re-loads no-ops. */
(function () {
  if (window.__tndEvtActions) return;
  window.__tndEvtActions = true;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  // Format a Date to an iCalendar UTC stamp: YYYYMMDDTHHMMSSZ
  function utcStamp(date) {
    if (!date || isNaN(date.getTime())) return null;
    return date.getUTCFullYear() + pad(date.getUTCMonth() + 1) + pad(date.getUTCDate())
      + 'T' + pad(date.getUTCHours()) + pad(date.getUTCMinutes()) + pad(date.getUTCSeconds()) + 'Z';
  }

  // iCalendar TEXT escaping (RFC 5545): backslash, newline, semicolon, comma
  function escICS(v) {
    return String(v || '')
      .replace(/\\/g, '\\\\')
      .replace(/\r?\n/g, '\\n')
      .replace(/;/g, '\\;')
      .replace(/,/g, '\\,');
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var icsBtn = t.closest('[data-ics-btn]');
    var shareBtn = t.closest('[data-share-btn]');

    if (icsBtn) {
      var root = icsBtn.closest('[data-evt-actions]');
      if (!root) return;
      var start = new Date(root.dataset.start);              // ISO incl. offset → absolute moment
      if (isNaN(start.getTime())) return;
      var end = root.dataset.end ? new Date(root.dataset.end) : null;
      if (!end || isNaN(end.getTime())) end = new Date(start.getTime() + 3 * 3600 * 1000);
      var stamp = utcStamp(new Date());
      var lines = [
        'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//The Nashville Distillery//Events//EN', 'CALSCALE:GREGORIAN',
        'BEGIN:VEVENT',
        'UID:' + (root.dataset.uid || start.getTime()) + '@thenashvilledistillery.com',
        'DTSTAMP:' + stamp,
        'DTSTART:' + utcStamp(start),
        'DTEND:' + utcStamp(end),
        'SUMMARY:' + escICS(root.dataset.title || 'Event'),
        'LOCATION:' + escICS(root.dataset.location || ''),
        'DESCRIPTION:' + escICS(root.dataset.details || ''),
        'END:VEVENT', 'END:VCALENDAR'
      ];
      var blob = new Blob([lines.join('\r\n')], { type: 'text/calendar;charset=utf-8' });
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = (root.dataset.title || 'event').replace(/[^a-z0-9]+/gi, '-').toLowerCase().replace(/^-|-$/g, '') + '.ics';
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      setTimeout(function () { URL.revokeObjectURL(url); }, 1500);
      return;
    }

    if (shareBtn) {
      var r = shareBtn.closest('[data-evt-actions]');
      var title = r ? r.dataset.title : document.title;
      var shareUrl = shareBtn.getAttribute('data-share-url') || location.href;
      var label = shareBtn.querySelector('[data-share-label]');
      if (navigator.share) {
        navigator.share({ title: title, text: title + ' — The Nashville Distillery', url: shareUrl }).catch(function () {});
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(shareUrl).then(function () {
          if (label) { var prev = label.textContent; label.textContent = 'Link copied'; setTimeout(function () { label.textContent = prev; }, 1800); }
        }).catch(function () {});
      }
    }
  });
})();
